/**
 * @file Navigation
 */

import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

/**
 * Navigation component
 */
const vNavigation = () => {
	const navigation = document.querySelector( '.v-navigation' );

	if ( ! navigation ) {
		return;
	}

	const parent    = navigation.parentNode;

	if ( ! parent.classList.contains( 'v-header__navigation-wrap-home' ) ) {
		return;
	}

	gsap.registerPlugin( ScrollTrigger );

	const notLogo     = navigation.querySelectorAll( '.v-navigation__title, .v-navigation__captions-wrap' );
	const logoWrap    = navigation.querySelector( '.v-navigation__gbmc-banner-wrap' );
	const logo        = navigation.querySelector( '.v-navigation__gbmc-logo-center' );
	const cta         = navigation.querySelector( '.v-navigation__cta' );
	const ctaContents = navigation.querySelectorAll( '.v-navigation__cta span' );
	const menuBtn     = navigation.querySelector( '.v-navigation__menu-btn' );

	ScrollTrigger.matchMedia( {
		'(min-width: 1024px)': () => {
			const tl                = gsap.timeline( {
				scrollTrigger: {
					trigger: '.v-header__navigation-wrap-home',
					start:   'top top',
					onEnter: () => {
						logoWrap.classList.add( 'v-navigation__gbmc-banner-wrap--visible' );
						menuBtn.setAttribute( 'aria-visible', 'true' );
					},
					onLeaveBack: () => {
						tl.reverse();
						cta.classList.add( 'v-navigation__cta--visible' );
					},
				},
				onReverseComplete: () => {
					logoWrap.classList.remove( 'v-navigation__gbmc-banner-wrap--visible' );
					cta.removeAttribute( 'style' );
					menuBtn.setAttribute( 'aria-visible', 'false' );
				},
				onComplete: () => {
					cta.classList.remove( 'v-navigation__cta--visible' );
					// cta.removeAttribute( 'style' );
				},
			} );

			tl
				.to( [ notLogo, ctaContents ], {
					opacity: 0,
				} )
				.fromTo( [ logo, menuBtn ], {
					opacity: 0,
					y:       '100%',
				}, {
					opacity: 1,
					y:       '0%',
				}, '<50%' );
		},
		'(max-width: 1023px)': () => {
			menuBtn.setAttribute( 'aria-visible', 'false' );
			if ( ! cta.classList.contains( 'v-navigation__cta--visible' ) ) {
				cta.classList.add( 'v-navigation__cta--visible' );
			}
		},
	} );
};

export default vNavigation;
